import { Component, OnInit } from '@angular/core';
import { DictionaryFuelTypeService } from '../../../app/shared/services/dictionary-fuel-type-service';
import { DictionaryFuelTypeEntity } from '../../../app/shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AddFuelTypeDialogComponent } from 'src/components/pages/dictionaries-fueltypes-tab/add-fuel-type-dialog/add-fuel-type-dialog.component';
import { DictionaryType } from '../../shared/dictionaries-layout';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from '../../../app/shared/fca-data-table';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDialogComponent } from '../../shared/error-dialog/error-dialog.component';

@Component({
  standalone: false,
  selector: 'dictionary-fueltypes-tab',
  templateUrl: './fueltypes.component.html',
  styleUrls: ['./fueltypes.component.scss'],
})
export class DictionaryFuelTypesTab implements OnInit {
  data: DictionaryFuelTypeEntity[] | null = null;
  pageSize = 10;

  dataDefinition: DataTableDataDefinition<DictionaryFuelTypeEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'FuelType',
          caption: 'Fuel Type',
          valueType: 'text',
          editable: false,
          deletable: true,
        },
      ],
    },
  ];

  constructor(
    private dataService: DictionaryFuelTypeService,
    public dialog: MatDialog
  ) {}

  title = 'Dictionary';
  dictionaryType = DictionaryType.FuelTypes;
  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData;
    });
  }

  customButtons: CustomButtonDefinition<DictionaryFuelTypeEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.confirmDelete.bind(this) as (x: any) => {},
    },
  ];

  isDialogOpen = false;

  addFuelType() {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(AddFuelTypeDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: { name: '' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataService.add({ FuelType: result, Id: undefined }).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 409) {
              this.dialog.open(ErrorDialogComponent, {
                data: { message: error.error.Message },
              });
            }
          },
        });
      }
      this.isDialogOpen = false;
    });
  }

  confirmDelete(fuelType: DictionaryFuelTypeEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.dataService.delete(fuelType).subscribe(() => {
          this.loadData();
        });
      }
    });
  }
}
